import $$ from "cmn-utils";
import { baseapi } from "../../../config";
// 示例
export function getDetail(data) {
  return $$.post(
    baseapi+'/cert_api/public/v1/detail_news',data
  );
}
